import React from 'react';
import './background.scss';

export const Checkout: React.FC = () => {
  return <div className="Checkout"></div>;
};
